import WistiaPlayer from "./WistiaPlayer";
export default WistiaPlayer;
